import { IQuoteToList } from '../../model';
import { getFirestore } from '../firebaseInitialize';
import { ICollectionReference } from './ICollectionReference';

export const quotesToListsRef = getFirestore().collection(
  'quotesToLists'
) as ICollectionReference<IQuoteToList>;
